import React from "react";
import { Navigate, useNavigate } from "react-router-dom";
import AuthenticatedNavbar from "../headers/AuthenticatedNavbar";
import AdminHiringPanel from "../AdminHiringPanel";
import { isAdmin } from "../../utils/userRole";

/**
 * Dedicated admin page to list, create, and moderate hiring posts.
 */
export default function HiringManagement({ user, onRefresh, onLogout }) {
  const navigate = useNavigate();

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (!isAdmin(user)) {
    return <Navigate to="/home" replace />;
  }

  return (
    <>
      <AuthenticatedNavbar user={user} onLogout={onLogout} />
      <div
        style={{
          maxWidth: 1000,
          margin: "24px auto 48px",
          padding: "20px",
          background: "#fff",
          borderRadius: 16,
          boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
        }}
      >
        <button
          type="button"
          onClick={() => navigate(-1)}
          style={{
            border: "none",
            background: "transparent",
            color: "#0f766e",
            cursor: "pointer",
            marginBottom: 8,
            padding: 0,
            fontSize: 14,
            fontWeight: 600,
          }}
        >
          ← Back
        </button>
        <AdminHiringPanel user={user} onRefresh={onRefresh} />
      </div>
    </>
  );
}
